import { render, staticRenderFns } from "./Impress.vue?vue&type=template&id=2f59ee7f&scoped=true&"
import script from "./Impress.vue?vue&type=script&lang=js&"
export * from "./Impress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59ee7f",
  null
  
)

export default component.exports